if (!customElements.get('cart-gift')) {
  class CartGift extends HTMLElement {
    constructor() {
      super();
      this.querySelector('input').addEventListener('change', this.updateCart.bind(this));
    }
    async updateCart(event) {
      const isChecked = event.target.checked;
      const line = this.dataset.itemLine;
      const response = await fetch(`${theme.routes.cart}.js`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const cart = await response.json();
      const cartItem = cart.items[line - 1];
      let properties = cartItem.properties;
      if (isChecked) {
        properties['Inpakken'] = 'Ja';
      }
      else {
        delete properties['Inpakken'];
      }
      const body = {
        line,
        properties,
      };
      fetch('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(async (response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
        })
        .catch((error) => {
          console.log(error.message);
          this.dispatchEvent(
            new CustomEvent('on:cart:error', {
              bubbles: true,
              detail: {
                error: error.message,
              },
            }),
          );
          window.location.reload();
        });
    }
  }
  customElements.define('cart-gift', CartGift);
}
//# sourceMappingURL=cart-gift.js.map
